var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsCrowdenergy236(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 99.2 99.2",
    style: {
      enableBackground: "new 0 0 99.2 99.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svg5673"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M24.6,17.1h50c4.6,0,8.2,3.7,8.2,8.3v48.5c0,4.6-3.7,8.3-8.2,8.3h-50 c-4.6,0-8.2-3.7-8.2-8.3V25.3C16.4,20.8,20.1,17.1,24.6,17.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 34.1,
    y: 43.1,
    fill: "#FFAF00",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    width: 4.2,
    height: 13
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 43.1,
    fill: "#FFAF00",
    stroke: "#FFAF00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    width: 4.2,
    height: 13
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCrowdenergy236);
export default __webpack_public_path__ + "static/media/icons-crowdenergy-236.de826a9fd9b1976b9416b9c5918bbfc0.svg";
export { ForwardRef as ReactComponent };